import styled from "@emotion/styled";

import { Flex } from "metabase/ui";

export const JoinConditionRoot = styled(Flex)`
  border-radius: 0.5rem;
  background-color: var(--mb-color-brand);
`;
